import styled from 'styled-components';
// import fadeIn from '~/styles/animations/fade-in';

export const Container = styled.div`
  height: 100%;
  padding: 30px;

  overflow-y: scroll;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 30px;
`;

export const Capitalize = styled.span`
  text-transform: capitalize;
`;

export const CharName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #eee;
`;
